import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router';

import { Clear } from 'components/icons';
import { trackLegacyEvent } from 'helpers/analytics';
import Recos from 'components/productdetail/Recos';
import css from 'styles/components/productdetail/outOfStockPopover.scss';
import marketplace from 'cfg/marketplace.json';
const { shortName } = marketplace;

const simLenLimit = 4;

/**
 * 6pm out of stock slide-in popover
 */
class OutOfStockPopover extends Component {
  state = {
    visible: null
  };

  componentDidUpdate(prevProps) {
    const { stock, onShow } = this.props;
    if (stock !== prevProps.stock) {
      this.setState({ visible: null });
    }
    if (!stock && prevProps.stock && this.state.visible === null) {
      onShow();
    }
  }

  onCloseClick = () => {
    this.setState({ visible: false });
  };

  onFormSubmit = e => {
    e.preventDefault();
    const { brandId, brandName, onBrandNotifySubmit } = this.props;
    const emailAddress = this.refs.brandSignupFormEmail.value;
    onBrandNotifySubmit({ brandId, brandName, emailAddress });
  };

  onRecoClicked = () => {
    trackLegacyEvent('More-Like-This', '6PM.product-page-matinee', 'Sidebar-Image-Click');
  };

  render() {
    const { testId } = this.context;
    const { visible } = this.state;
    const { recos, stock, brandId, brandName, isSubmitted } = this.props;
    const similarItems = recos && recos.results && recos.results.length ? recos.results.slice(0, simLenLimit) : [];

    // Set initial visibility based on props (product is out of stock)
    // Subsequently, it should respect local state visibility when close button is clicked
    const isVisible = visible !== null ? visible : !stock;

    const additionalMelodyCardProductClasses = {
      brandName: css.melodyCardProductBrandName,
      container: css.melodyCardProductContainer,
      image: css.melodyCardProductImage,
      priceContainer: css.melodyCardProductPriceContainer,
      textContainer: css.melodyCardProductTextContainer
    };

    return (
      <div data-test-id={testId('oosPopover')} className={cn(css.oosPopover, { [css.slideIn]: isVisible })}>
        <h1>Sorry, this is out of stock. You just missed it.</h1>
        <div className={css.oosMlt}>
          <h2>But check out these similar styles available:</h2>
          <div className={css.recosWrapper}>
            <Recos
              additionalMelodyCardProductClasses={additionalMelodyCardProductClasses}
              noBackground={true}
              onRecoClicked={this.onRecoClicked}
              recos={similarItems}
              recoType="oosRecos"
              showTitle={false} />
          </div>
        </div>
        <div className={css.oosNotifyBox}>
          <form method="post" onSubmit={this.onFormSubmit}>
            {!isSubmitted && <p> Sign up to receive {brandName} deals as they become available!</p>}
            {isSubmitted && <p className={css.successMessage}> You are now signed up to receive the latest {brandName} notifications!</p>}
            {!isSubmitted && (
              <div>
                <input
                  ref="brandSignupFormEmail"
                  className={css.emailInput}
                  type="email"
                  required={true}
                  name="emailSubscription.emailAddress"
                  defaultValue=""
                  placeholder="Email Address"
                  data-test-id={testId('emailAddress')}/>
                <input type="hidden" value={brandId} name="brandId"/>
                <input type="hidden" value={brandName} name="brandName"/>
                <button
                  id="oosSubmit"
                  type="submit"
                  data-track-action="Product-Page"
                  data-track-label="OOS"
                  data-track-value="Notify-Me-Submit"
                  data-test-id={testId('oosSubmit')}>Notify Me</button>
              </div>
            )}
          </form>
        </div>
        <p className={css.privacyMessage}>
          {shortName} will never sell your information. Read our <Link to="/c/privacy-policy">Privacy Policy.</Link>
        </p>
        <Clear className={css.close} size={22} onClick={this.onCloseClick} />
      </div>
    );
  }
}

OutOfStockPopover.propTypes = {
  brandId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  brandName: PropTypes.string.isRequired,
  onBrandNotifySubmit: PropTypes.func.isRequired,
  recos : PropTypes.object,
  stock: PropTypes.object,
  isSubmitted: PropTypes.bool
};

OutOfStockPopover.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default OutOfStockPopover;
